(() => {
  const selector = '#free-shipping-bar';
  let requestId = 0;
  let timer;

  const money = (cents, currency, sample) => {
    const prefix = String(sample || '').match(/^\s*([^\d-]*)/)?.[1] || '';
    const amount = (Math.max(0, cents) / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    if (prefix.trim()) return `${prefix}${amount}`;
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Math.max(0, cents) / 100);
  };

  const render = (bar, totalCents) => {
    const threshold = Number(bar.dataset.thresholdCents || 0);
    const currency = bar.dataset.currency || window.Shopify?.currency?.active || 'USD';
    if (!threshold) return;
    const remaining = threshold - Number(totalCents || 0);
    const message = bar.querySelector('.free-shipping-bar__message');
    const fill = bar.querySelector('.free-shipping-bar__fill');
    const sample = message?.querySelector('strong')?.textContent || '';
    if (message) {
      if (remaining > 0) message.innerHTML = `You're <strong>${money(remaining, currency, sample)}</strong> away from free shipping!`;
      else message.textContent = "🎉 You've unlocked free shipping!";
    }
    if (fill) fill.style.width = `${Math.min(100, Math.max(0, Number(totalCents || 0) / threshold * 100))}%`;
  };

  const refresh = async () => {
    const bar = document.querySelector(selector);
    if (!bar) return;
    const id = ++requestId;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (id === requestId) render(bar, cart.total_price);
    } catch (_) {}
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(refresh, 450);
    setTimeout(refresh, 1200);
    setTimeout(refresh, 3500);
    setTimeout(refresh, 8000);
  };

  ['cart:updated', 'cart:change', 'cart:refresh', 'theme:cart:change', 'product:added', 'ajaxProduct:added', 'rebuy:cart.change', 'rebuy:cart.add']
    .forEach(name => document.addEventListener(name, schedule));
  document.addEventListener('click', event => {
    if (event.target.closest('[data-product-form], [data-cart-item], [aria-label*="quantity" i], [name="plus"], [name="minus"], .rebuy-cart__flyout-item-quantity-widget-button')) schedule();
  });
  document.addEventListener('change', event => {
    if (event.target.closest('input[name="updates[]"], [data-cart-item]')) schedule();
  });
  const observer = new MutationObserver(mutations => {
    const cartChanged = mutations.some(mutation => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target.parentElement;
      return target
        && !target.closest(selector)
        && target.closest('cart-drawer, cart-drawer-items, .cart-drawer, [data-cart-drawer], #CartDrawer, .rebuy-cart__flyout');
    });
    if (cartChanged) schedule();
  });
  observer.observe(document.body, { subtree: true, childList: true, characterData: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
